import $ from 'jquery';

export default class SimpleDropzone {
	init() {
		$('.dropzone').each(function () {
			const $dropzone = $(this);
			const $form = $dropzone.closest('form');
			const uploadRequired =
				$dropzone.find('input[type=file][required]').length > 0;
			const $fileListDescription = $dropzone.next('.help-block');
			const $originalDescription = `<div class="original-description">${$fileListDescription.html()}</div>`;
			$fileListDescription.html($originalDescription);

			$(this).on('dragover', function () {
				$(this).addClass('hover');
			});

			$(this).on('dragleave', function () {
				$(this).removeClass('hover');
			});

			$(this).on('drop', function () {
				$(this).removeClass('hover');
			});

			function initInputs($inputs) {
				$inputs.on('change', (e) => {
					const $input = $(e.target);
					if (!$input[0].files.length) {
						return;
					}
					const maximumTotalFileSize = Number.parseInt(
						$dropzone.attr('data-maximum-total-file-size'),
						10,
					);

					if (
						Number.isFinite(maximumTotalFileSize) &&
						getTotalFileSize($form) > maximumTotalFileSize
					) {
						$input.val('');
						showFileSizeError(
							$fileListDescription,
							$dropzone.attr('data-maximum-total-file-size-message'),
						);
						return;
					}

					$fileListDescription.find('.file-size-error').remove();
					if ($input.attr('name').includes('[]')) {
						//Clone the input
						const $cloneInput = $input.clone();
						$cloneInput
							.attr('id', `fileuploadmultiple-${getNextMultiFileUploadId()}`)
							.val('');
						$input.after($cloneInput);
						$input.hide();

						//Init newly created input
						initInputs($cloneInput);
						updateRequiredInputs();
					}
					//Add the file to the list
					const filesAsString = Object.keys($input[0].files)
						.map((x) => $input[0].files[x].name)
						.join(', ');
					$fileListDescription.append(
						`<div class="file-list-item"><span class="file-list-item-name">${filesAsString}</span><div class="remove-btn" id="${$input.attr('id')}-remove" title="Entfernen"></div></div>`,
					);

					if ($fileListDescription.find('.file-list-item').length) {
						$fileListDescription.find('.original-description').hide();
					}

					$(`#${$input.attr('id')}-remove`).click(function () {
						if ($input.attr('name').includes('[]')) {
							$input.remove();
							updateRequiredInputs();
						}
						$(this).parent().remove();
						if (!$fileListDescription.find('.file-list-item').length) {
							$fileListDescription.find('.original-description').show();
						}
					});
				});
			}

			function updateRequiredInputs() {
				const $inputs = $dropzone.find('input[type=file]');
				const hasFiles = $inputs
					.toArray()
					.some((input) => input.files.length > 0);
				// The upload group is required, not the empty input for additional files.
				$inputs.prop('required', uploadRequired && !hasFiles);
				const validator = $form.data('validator');
				if (validator) {
					$inputs.filter(':visible').each(function () {
						validator.element(this);
					});
				}
			}

			initInputs($dropzone.find('input[type=file]'));
		});

		function getNextMultiFileUploadId() {
			let id = 0;
			$('.dropzone')
				.find('input')
				.each(function () {
					const currentId = Number.parseInt(
						$(this).attr('id').replace('fileuploadmultiple-', ''),
					);
					if (currentId > id) {
						id = currentId;
					}
				});
			return id + 1;
		}

		function getTotalFileSize($form) {
			return $form
				.find('input[type=file]')
				.toArray()
				.reduce(
					(totalSize, input) =>
						totalSize +
						Array.from(input.files ?? []).reduce(
							(fileSize, file) => fileSize + file.size,
							0,
						),
					0,
				);
		}

		function showFileSizeError($fileListDescription, message) {
			$fileListDescription.find('.file-size-error').remove();
			$fileListDescription.append(
				$('<div>', {
					class: 'file-size-error error-label',
					text:
						message ||
						'Die ausgewählten Dateien überschreiten die zulässige Gesamtgröße.',
				}),
			);
		}
	}
}
